import { createAction } from '@reduxjs/toolkit';
import {
    TPasswordResetResponse,
    TUser,
    TUserResponse,
} from '../../utils/types';

export const getPasswordResetSuccess = createAction<
    TPasswordResetResponse,
    'passwordReset/GET_SUCCESS'
>('passwordReset/GET_SUCCESS');
export const getPasswordResetFailed = createAction<
    string,
    'passwordReset/GET_FAILED'
>('passwordReset/GET_FAILED');
export const getPasswordResetClear = createAction('passwordReset/GET_CLEAR');
export const getPasswordRestoreSuccess = createAction(
    'passwordRestore/GET_SUCCESS'
);
export const getPasswordRestoreFailed = createAction<
    string,
    'passwordRestore/GET_FAILED'
>('passwordRestore/GET_FAILED');
export const getRegisterSuccess = createAction(
    'register/GET_SUCCESS',
    (item) => ({
        payload: {
            ...item,
            accessToken: item.accessToken.replace('Bearer ', ''),
        },
    })
);
export const getRegisterFailed = createAction<string, 'register/GET_FAILED'>(
    'register/GET_FAILED'
);

export const getLoginSuccess = createAction('login/GET_SUCCESS', (item) => ({
    payload: {
        ...item,
        accessToken: item.accessToken.replace('Bearer ', ''),
    },
}));
export const getLoginFailed = createAction<string, 'login/GET_FAILED'>(
    'login/GET_FAILED'
);

export const getUserSuccess = createAction<TUserResponse, 'user/GET_SUCCESS'>(
    'user/GET_SUCCESS'
);
export const getUserFailed = createAction('user/GET_FAILED');
export const getUserUpdateSuccess = createAction('user/GET_UPDATE_SUCCESS');
export const getUserUpdateFailed = createAction<
    string,
    'user/GET_UPDATE_FAILED'
>('user/GET_UPDATE_FAILED');
export const checkedAuth = createAction('user/CHECKED_AUTH');

export const setUser = createAction<TUser | null, 'user/SET'>('user/SET');

export type TAuthActions =
    | ReturnType<typeof getPasswordRestoreSuccess>
    | ReturnType<typeof getPasswordRestoreFailed>
    | ReturnType<typeof getPasswordResetClear>
    | ReturnType<typeof getPasswordResetSuccess>
    | ReturnType<typeof getPasswordResetFailed>
    | ReturnType<typeof getRegisterSuccess>
    | ReturnType<typeof getRegisterFailed>
    | ReturnType<typeof getLoginSuccess>
    | ReturnType<typeof getLoginFailed>
    | ReturnType<typeof getUserSuccess>
    | ReturnType<typeof getUserFailed>
    | ReturnType<typeof setUser>
    | ReturnType<typeof getUserUpdateSuccess>
    | ReturnType<typeof getUserUpdateFailed>
    | ReturnType<typeof checkedAuth>;
